// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/agent/v1/conversation.proto (package chalk.agent.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AgentTemplateInputValue } from "./agent_template_pb";
import { file_chalk_agent_v1_agent_template } from "./agent_template_pb";
import { file_chalk_auth_v1_permissions } from "../../auth/v1/permissions_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/agent/v1/conversation.proto.
 */
export const file_chalk_agent_v1_conversation: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_agent_v1_agent_template, file_chalk_auth_v1_permissions, file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.agent.v1.AgentConversation
 */
export type AgentConversation = Message<"chalk.agent.v1.AgentConversation"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string environment_id = 2;
   */
  environmentId: string;

  /**
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * @generated from field: google.protobuf.Struct metadata = 5;
   */
  metadata?: JsonObject;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp;

  /**
   * Optional AiProviderConnection id this conversation is pinned to. When set,
   * the runner builds its provider client from that connection's host + secret.
   *
   * @generated from field: string ai_provider_connection_id = 8;
   */
  aiProviderConnectionId: string;

  /**
   * Optional model id (e.g. "gpt-4o-mini") preferred for this conversation.
   * RunTurnRequest.model still wins when set; otherwise this overrides the
   * template, connection, and provider defaults.
   *
   * @generated from field: string model_name = 9;
   */
  modelName: string;

  /**
   * Lifecycle status. Maintained by the runner (IN_PROGRESS while a turn is
   * running, AWAITING_USER_INPUT when it ends); COMPLETED is set explicitly
   * via UpdateConversation.
   *
   * @generated from field: chalk.agent.v1.AgentConversationStatus status = 10;
   */
  status: AgentConversationStatus;

  /**
   * Optional AgentTemplate this conversation was created from. When set, the
   * runner applies the template's system prompt, uses its model /
   * ai_provider_connection as fallbacks, and restricts tools to the
   * template's allowed_tools (see agent_template.proto).
   *
   * @generated from field: string agent_template_id = 11;
   */
  agentTemplateId: string;

  /**
   * Values supplied for the template's declared inputs when the conversation
   * was created, keyed by input name. Empty when the template declares no
   * inputs (or the conversation has no template).
   *
   * @generated from field: map<string, chalk.agent.v1.AgentTemplateInputValue> template_inputs = 12;
   */
  templateInputs: { [key: string]: AgentTemplateInputValue };
};

/**
 * Describes the message chalk.agent.v1.AgentConversation.
 * Use `create(AgentConversationSchema)` to create a new message.
 */
export const AgentConversationSchema: GenMessage<AgentConversation> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 0);

/**
 * A link between a conversation and an external resource it created or
 * touched (a notebook, a sandbox, ...). Linking is idempotent on
 * (conversation, kind, artifact_id).
 *
 * @generated from message chalk.agent.v1.AgentConversationArtifact
 */
export type AgentConversationArtifact = Message<"chalk.agent.v1.AgentConversationArtifact"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string conversation_id = 2;
   */
  conversationId: string;

  /**
   * @generated from field: chalk.agent.v1.AgentArtifactKind kind = 3;
   */
  kind: AgentArtifactKind;

  /**
   * Id of the linked resource, e.g. a notebook id or sandbox id.
   *
   * @generated from field: string artifact_id = 4;
   */
  artifactId: string;

  /**
   * @generated from field: google.protobuf.Struct metadata = 5;
   */
  metadata?: JsonObject;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message chalk.agent.v1.AgentConversationArtifact.
 * Use `create(AgentConversationArtifactSchema)` to create a new message.
 */
export const AgentConversationArtifactSchema: GenMessage<AgentConversationArtifact> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 1);

/**
 * @generated from message chalk.agent.v1.AgentMessage
 */
export type AgentMessage = Message<"chalk.agent.v1.AgentMessage"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string conversation_id = 2;
   */
  conversationId: string;

  /**
   * @generated from field: chalk.agent.v1.AgentMessageRole role = 3;
   */
  role: AgentMessageRole;

  /**
   * @generated from field: google.protobuf.Struct content = 4;
   */
  content?: JsonObject;

  /**
   * @generated from field: string parent_message_id = 5;
   */
  parentMessageId: string;

  /**
   * @generated from field: int32 sequence = 6;
   */
  sequence: number;

  /**
   * @generated from field: chalk.agent.v1.AgentMessageStatus status = 7;
   */
  status: AgentMessageStatus;

  /**
   * @generated from field: google.protobuf.Struct metadata = 8;
   */
  metadata?: JsonObject;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: repeated chalk.agent.v1.AgentToolCall tool_calls = 10;
   */
  toolCalls: AgentToolCall[];
};

/**
 * Describes the message chalk.agent.v1.AgentMessage.
 * Use `create(AgentMessageSchema)` to create a new message.
 */
export const AgentMessageSchema: GenMessage<AgentMessage> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 2);

/**
 * @generated from message chalk.agent.v1.AgentToolCall
 */
export type AgentToolCall = Message<"chalk.agent.v1.AgentToolCall"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string conversation_id = 2;
   */
  conversationId: string;

  /**
   * @generated from field: string assistant_message_id = 3;
   */
  assistantMessageId: string;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.Struct arguments = 5;
   */
  arguments?: JsonObject;

  /**
   * @generated from field: chalk.agent.v1.AgentToolCallStatus status = 6;
   */
  status: AgentToolCallStatus;

  /**
   * @generated from field: string idempotency_key = 7;
   */
  idempotencyKey: string;

  /**
   * @generated from field: string trace_id = 8;
   */
  traceId: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: chalk.agent.v1.AgentToolResult result = 10;
   */
  result?: AgentToolResult;
};

/**
 * Describes the message chalk.agent.v1.AgentToolCall.
 * Use `create(AgentToolCallSchema)` to create a new message.
 */
export const AgentToolCallSchema: GenMessage<AgentToolCall> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 3);

/**
 * @generated from message chalk.agent.v1.AgentToolResult
 */
export type AgentToolResult = Message<"chalk.agent.v1.AgentToolResult"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string tool_call_id = 2;
   */
  toolCallId: string;

  /**
   * @generated from field: bool is_error = 3;
   */
  isError: boolean;

  /**
   * @generated from field: google.protobuf.Struct result = 4;
   */
  result?: JsonObject;

  /**
   * @generated from field: string raw_text = 5;
   */
  rawText: string;

  /**
   * @generated from field: int32 latency_ms = 6;
   */
  latencyMs: number;

  /**
   * @generated from field: google.protobuf.Struct metadata = 7;
   */
  metadata?: JsonObject;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;
};

/**
 * Describes the message chalk.agent.v1.AgentToolResult.
 * Use `create(AgentToolResultSchema)` to create a new message.
 */
export const AgentToolResultSchema: GenMessage<AgentToolResult> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 4);

/**
 * @generated from message chalk.agent.v1.CreateConversationRequest
 */
export type CreateConversationRequest = Message<"chalk.agent.v1.CreateConversationRequest"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: google.protobuf.Struct metadata = 2;
   */
  metadata?: JsonObject;

  /**
   * Deprecated: newly-created conversations always use the environment's
   * default AI provider connection. Retained for wire compatibility and
   * ignored by the server.
   *
   * @generated from field: string ai_provider_connection_id = 3 [deprecated = true];
   * @deprecated
   */
  aiProviderConnectionId: string;

  /**
   * Optional: persisted preferred model for the conversation.
   *
   * @generated from field: string model_name = 4;
   */
  modelName: string;

  /**
   * Optional: create the conversation from an AgentTemplate. Must reference a
   * template in the caller's environment.
   *
   * @generated from field: string agent_template_id = 5;
   */
  agentTemplateId: string;

  /**
   * Values for the template's declared inputs, keyed by input name. Only
   * legal alongside agent_template_id. Every non-nullable declared input must
   * be supplied with a value of its declared type; nullable inputs may be
   * omitted or explicitly null. Unknown keys are rejected.
   *
   * @generated from field: map<string, chalk.agent.v1.AgentTemplateInputValue> template_inputs = 6;
   */
  templateInputs: { [key: string]: AgentTemplateInputValue };

  /**
   * Stable caller-generated key for retrying the two-plane creation workflow.
   * Reusing a key in one environment returns the same conversation.
   *
   * @generated from field: string idempotency_key = 7;
   */
  idempotencyKey: string;

  /**
   * Context field used to generate the conversation title
   *
   * @generated from field: optional string title_context_text = 8;
   */
  titleContextText?: string;
};

/**
 * Describes the message chalk.agent.v1.CreateConversationRequest.
 * Use `create(CreateConversationRequestSchema)` to create a new message.
 */
export const CreateConversationRequestSchema: GenMessage<CreateConversationRequest> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 5);

/**
 * @generated from message chalk.agent.v1.CreateConversationResponse
 */
export type CreateConversationResponse = Message<"chalk.agent.v1.CreateConversationResponse"> & {
  /**
   * @generated from field: chalk.agent.v1.AgentConversation conversation = 1;
   */
  conversation?: AgentConversation;
};

/**
 * Describes the message chalk.agent.v1.CreateConversationResponse.
 * Use `create(CreateConversationResponseSchema)` to create a new message.
 */
export const CreateConversationResponseSchema: GenMessage<CreateConversationResponse> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 6);

/**
 * @generated from message chalk.agent.v1.GetConversationRequest
 */
export type GetConversationRequest = Message<"chalk.agent.v1.GetConversationRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chalk.agent.v1.GetConversationRequest.
 * Use `create(GetConversationRequestSchema)` to create a new message.
 */
export const GetConversationRequestSchema: GenMessage<GetConversationRequest> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 7);

/**
 * @generated from message chalk.agent.v1.GetConversationResponse
 */
export type GetConversationResponse = Message<"chalk.agent.v1.GetConversationResponse"> & {
  /**
   * @generated from field: chalk.agent.v1.AgentConversation conversation = 1;
   */
  conversation?: AgentConversation;
};

/**
 * Describes the message chalk.agent.v1.GetConversationResponse.
 * Use `create(GetConversationResponseSchema)` to create a new message.
 */
export const GetConversationResponseSchema: GenMessage<GetConversationResponse> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 8);

/**
 * The fork-connected component containing conversation_id. It includes
 * visible ancestors, descendants, and sibling branches, but never resolves
 * transcript content from the environment data plane.
 *
 * @generated from message chalk.agent.v1.GetConversationForkFamilyRequest
 */
export type GetConversationForkFamilyRequest = Message<"chalk.agent.v1.GetConversationForkFamilyRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;
};

/**
 * Describes the message chalk.agent.v1.GetConversationForkFamilyRequest.
 * Use `create(GetConversationForkFamilyRequestSchema)` to create a new message.
 */
export const GetConversationForkFamilyRequestSchema: GenMessage<GetConversationForkFamilyRequest> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 9);

/**
 * @generated from message chalk.agent.v1.GetConversationForkFamilyResponse
 */
export type GetConversationForkFamilyResponse = Message<"chalk.agent.v1.GetConversationForkFamilyResponse"> & {
  /**
   * @generated from field: repeated chalk.agent.v1.AgentConversation conversations = 1;
   */
  conversations: AgentConversation[];
};

/**
 * Describes the message chalk.agent.v1.GetConversationForkFamilyResponse.
 * Use `create(GetConversationForkFamilyResponseSchema)` to create a new message.
 */
export const GetConversationForkFamilyResponseSchema: GenMessage<GetConversationForkFamilyResponse> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 10);

/**
 * Server-side filters for the conversations directory. Each field uses
 * positive "is any of" semantics; empty fields do not filter.
 *
 * @generated from message chalk.agent.v1.ListConversationsFilters
 */
export type ListConversationsFilters = Message<"chalk.agent.v1.ListConversationsFilters"> & {
  /**
   * @generated from field: repeated chalk.agent.v1.AgentConversationStatus statuses = 1;
   */
  statuses: AgentConversationStatus[];

  /**
   * @generated from field: repeated string user_ids = 2;
   */
  userIds: string[];

  /**
   * @generated from field: repeated string model_names = 3;
   */
  modelNames: string[];

  /**
   * @generated from field: repeated string agent_template_ids = 4;
   */
  agentTemplateIds: string[];
};

/**
 * Describes the message chalk.agent.v1.ListConversationsFilters.
 * Use `create(ListConversationsFiltersSchema)` to create a new message.
 */
export const ListConversationsFiltersSchema: GenMessage<ListConversationsFilters> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 11);

/**
 * @generated from message chalk.agent.v1.ListConversationsRequest
 */
export type ListConversationsRequest = Message<"chalk.agent.v1.ListConversationsRequest"> & {
  /**
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * @generated from field: string cursor = 2;
   */
  cursor: string;

  /**
   * Deprecated in favor of filters.user_ids. Retained for existing clients.
   *
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * @generated from field: chalk.agent.v1.ListConversationsFilters filters = 4;
   */
  filters?: ListConversationsFilters;

  /**
   * Case-insensitive literal substring search over conversation titles.
   *
   * @generated from field: string search = 5;
   */
  search: string;

  /**
   * Sort key and direction. Unset defaults to created_at DESC, matching the
   * ordering existing callers relied on before these fields existed. A cursor
   * is only valid for the sort it was issued under.
   *
   * @generated from field: chalk.agent.v1.AgentConversationSortColumn sort_column = 6;
   */
  sortColumn: AgentConversationSortColumn;

  /**
   * @generated from field: chalk.agent.v1.AgentConversationSortOrder sort_order = 7;
   */
  sortOrder: AgentConversationSortOrder;
};

/**
 * Describes the message chalk.agent.v1.ListConversationsRequest.
 * Use `create(ListConversationsRequestSchema)` to create a new message.
 */
export const ListConversationsRequestSchema: GenMessage<ListConversationsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 12);

/**
 * @generated from message chalk.agent.v1.ListConversationsResponse
 */
export type ListConversationsResponse = Message<"chalk.agent.v1.ListConversationsResponse"> & {
  /**
   * @generated from field: repeated chalk.agent.v1.AgentConversation conversations = 1;
   */
  conversations: AgentConversation[];

  /**
   * @generated from field: string next_cursor = 2;
   */
  nextCursor: string;
};

/**
 * Describes the message chalk.agent.v1.ListConversationsResponse.
 * Use `create(ListConversationsResponseSchema)` to create a new message.
 */
export const ListConversationsResponseSchema: GenMessage<ListConversationsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 13);

/**
 * @generated from message chalk.agent.v1.UpdateConversationRequest
 */
export type UpdateConversationRequest = Message<"chalk.agent.v1.UpdateConversationRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: google.protobuf.Struct metadata = 3;
   */
  metadata?: JsonObject;

  /**
   * When not UNSPECIFIED, sets the conversation's lifecycle status (e.g. mark
   * a conversation COMPLETED, or reopen it with AWAITING_USER_INPUT).
   *
   * @generated from field: chalk.agent.v1.AgentConversationStatus status = 4;
   */
  status: AgentConversationStatus;
};

/**
 * Describes the message chalk.agent.v1.UpdateConversationRequest.
 * Use `create(UpdateConversationRequestSchema)` to create a new message.
 */
export const UpdateConversationRequestSchema: GenMessage<UpdateConversationRequest> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 14);

/**
 * @generated from message chalk.agent.v1.UpdateConversationResponse
 */
export type UpdateConversationResponse = Message<"chalk.agent.v1.UpdateConversationResponse"> & {
  /**
   * @generated from field: chalk.agent.v1.AgentConversation conversation = 1;
   */
  conversation?: AgentConversation;
};

/**
 * Describes the message chalk.agent.v1.UpdateConversationResponse.
 * Use `create(UpdateConversationResponseSchema)` to create a new message.
 */
export const UpdateConversationResponseSchema: GenMessage<UpdateConversationResponse> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 15);

/**
 * @generated from message chalk.agent.v1.DeleteConversationRequest
 */
export type DeleteConversationRequest = Message<"chalk.agent.v1.DeleteConversationRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chalk.agent.v1.DeleteConversationRequest.
 * Use `create(DeleteConversationRequestSchema)` to create a new message.
 */
export const DeleteConversationRequestSchema: GenMessage<DeleteConversationRequest> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 16);

/**
 * @generated from message chalk.agent.v1.DeleteConversationResponse
 */
export type DeleteConversationResponse = Message<"chalk.agent.v1.DeleteConversationResponse"> & {
};

/**
 * Describes the message chalk.agent.v1.DeleteConversationResponse.
 * Use `create(DeleteConversationResponseSchema)` to create a new message.
 */
export const DeleteConversationResponseSchema: GenMessage<DeleteConversationResponse> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 17);

/**
 * @generated from message chalk.agent.v1.ForkConversationRequest
 */
export type ForkConversationRequest = Message<"chalk.agent.v1.ForkConversationRequest"> & {
  /**
   * Conversation to fork. Must belong to the caller's environment.
   *
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * Optional message to fork at: history up to and including this message is
   * copied into the fork. Empty copies the whole conversation.
   *
   * @generated from field: string message_id = 2;
   */
  messageId: string;

  /**
   * Optional title for the fork. Empty derives one from the source title.
   *
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * Stable caller-generated key for retrying a fork after a partial write.
   *
   * @generated from field: string idempotency_key = 4;
   */
  idempotencyKey: string;

  /**
   * @generated from field: chalk.agent.v1.ForkProviderSource provider_source = 5;
   */
  providerSource: ForkProviderSource;
};

/**
 * Describes the message chalk.agent.v1.ForkConversationRequest.
 * Use `create(ForkConversationRequestSchema)` to create a new message.
 */
export const ForkConversationRequestSchema: GenMessage<ForkConversationRequest> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 18);

/**
 * @generated from message chalk.agent.v1.ForkConversationResponse
 */
export type ForkConversationResponse = Message<"chalk.agent.v1.ForkConversationResponse"> & {
  /**
   * @generated from field: chalk.agent.v1.AgentConversation conversation = 1;
   */
  conversation?: AgentConversation;
};

/**
 * Describes the message chalk.agent.v1.ForkConversationResponse.
 * Use `create(ForkConversationResponseSchema)` to create a new message.
 */
export const ForkConversationResponseSchema: GenMessage<ForkConversationResponse> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 19);

/**
 * @generated from message chalk.agent.v1.LinkArtifactRequest
 */
export type LinkArtifactRequest = Message<"chalk.agent.v1.LinkArtifactRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: chalk.agent.v1.AgentArtifactKind kind = 2;
   */
  kind: AgentArtifactKind;

  /**
   * @generated from field: string artifact_id = 3;
   */
  artifactId: string;

  /**
   * Optional details about the link (e.g. a display name). On re-link of an
   * existing (conversation, kind, artifact_id), non-empty metadata replaces
   * the stored metadata; empty metadata leaves it unchanged.
   *
   * @generated from field: google.protobuf.Struct metadata = 4;
   */
  metadata?: JsonObject;
};

/**
 * Describes the message chalk.agent.v1.LinkArtifactRequest.
 * Use `create(LinkArtifactRequestSchema)` to create a new message.
 */
export const LinkArtifactRequestSchema: GenMessage<LinkArtifactRequest> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 20);

/**
 * @generated from message chalk.agent.v1.LinkArtifactResponse
 */
export type LinkArtifactResponse = Message<"chalk.agent.v1.LinkArtifactResponse"> & {
  /**
   * @generated from field: chalk.agent.v1.AgentConversationArtifact artifact = 1;
   */
  artifact?: AgentConversationArtifact;
};

/**
 * Describes the message chalk.agent.v1.LinkArtifactResponse.
 * Use `create(LinkArtifactResponseSchema)` to create a new message.
 */
export const LinkArtifactResponseSchema: GenMessage<LinkArtifactResponse> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 21);

/**
 * @generated from message chalk.agent.v1.UnlinkArtifactRequest
 */
export type UnlinkArtifactRequest = Message<"chalk.agent.v1.UnlinkArtifactRequest"> & {
  /**
   * Id of the artifact link row (AgentConversationArtifact.id).
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message chalk.agent.v1.UnlinkArtifactRequest.
 * Use `create(UnlinkArtifactRequestSchema)` to create a new message.
 */
export const UnlinkArtifactRequestSchema: GenMessage<UnlinkArtifactRequest> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 22);

/**
 * @generated from message chalk.agent.v1.UnlinkArtifactResponse
 */
export type UnlinkArtifactResponse = Message<"chalk.agent.v1.UnlinkArtifactResponse"> & {
};

/**
 * Describes the message chalk.agent.v1.UnlinkArtifactResponse.
 * Use `create(UnlinkArtifactResponseSchema)` to create a new message.
 */
export const UnlinkArtifactResponseSchema: GenMessage<UnlinkArtifactResponse> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 23);

/**
 * @generated from message chalk.agent.v1.ListArtifactsRequest
 */
export type ListArtifactsRequest = Message<"chalk.agent.v1.ListArtifactsRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;
};

/**
 * Describes the message chalk.agent.v1.ListArtifactsRequest.
 * Use `create(ListArtifactsRequestSchema)` to create a new message.
 */
export const ListArtifactsRequestSchema: GenMessage<ListArtifactsRequest> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 24);

/**
 * @generated from message chalk.agent.v1.ListArtifactsResponse
 */
export type ListArtifactsResponse = Message<"chalk.agent.v1.ListArtifactsResponse"> & {
  /**
   * @generated from field: repeated chalk.agent.v1.AgentConversationArtifact artifacts = 1;
   */
  artifacts: AgentConversationArtifact[];
};

/**
 * Describes the message chalk.agent.v1.ListArtifactsResponse.
 * Use `create(ListArtifactsResponseSchema)` to create a new message.
 */
export const ListArtifactsResponseSchema: GenMessage<ListArtifactsResponse> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 25);

/**
 * Reverse lookup: conversations linked to a given artifact (e.g. all
 * conversations that touched a notebook).
 *
 * @generated from message chalk.agent.v1.ListConversationsForArtifactRequest
 */
export type ListConversationsForArtifactRequest = Message<"chalk.agent.v1.ListConversationsForArtifactRequest"> & {
  /**
   * @generated from field: chalk.agent.v1.AgentArtifactKind kind = 1;
   */
  kind: AgentArtifactKind;

  /**
   * @generated from field: string artifact_id = 2;
   */
  artifactId: string;

  /**
   * @generated from field: int32 page_size = 3;
   */
  pageSize: number;
};

/**
 * Describes the message chalk.agent.v1.ListConversationsForArtifactRequest.
 * Use `create(ListConversationsForArtifactRequestSchema)` to create a new message.
 */
export const ListConversationsForArtifactRequestSchema: GenMessage<ListConversationsForArtifactRequest> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 26);

/**
 * @generated from message chalk.agent.v1.ListConversationsForArtifactResponse
 */
export type ListConversationsForArtifactResponse = Message<"chalk.agent.v1.ListConversationsForArtifactResponse"> & {
  /**
   * @generated from field: repeated chalk.agent.v1.AgentConversation conversations = 1;
   */
  conversations: AgentConversation[];
};

/**
 * Describes the message chalk.agent.v1.ListConversationsForArtifactResponse.
 * Use `create(ListConversationsForArtifactResponseSchema)` to create a new message.
 */
export const ListConversationsForArtifactResponseSchema: GenMessage<ListConversationsForArtifactResponse> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 27);

/**
 * @generated from message chalk.agent.v1.AddMessageRequest
 */
export type AddMessageRequest = Message<"chalk.agent.v1.AddMessageRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: chalk.agent.v1.AgentMessageRole role = 2;
   */
  role: AgentMessageRole;

  /**
   * @generated from field: google.protobuf.Struct content = 3;
   */
  content?: JsonObject;

  /**
   * @generated from field: string parent_message_id = 4;
   */
  parentMessageId: string;

  /**
   * @generated from field: chalk.agent.v1.AgentMessageStatus status = 5;
   */
  status: AgentMessageStatus;

  /**
   * @generated from field: google.protobuf.Struct metadata = 6;
   */
  metadata?: JsonObject;

  /**
   * @generated from field: repeated chalk.agent.v1.AddToolCallRequest tool_calls = 7;
   */
  toolCalls: AddToolCallRequest[];
};

/**
 * Describes the message chalk.agent.v1.AddMessageRequest.
 * Use `create(AddMessageRequestSchema)` to create a new message.
 */
export const AddMessageRequestSchema: GenMessage<AddMessageRequest> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 28);

/**
 * @generated from message chalk.agent.v1.AddToolCallRequest
 */
export type AddToolCallRequest = Message<"chalk.agent.v1.AddToolCallRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.Struct arguments = 2;
   */
  arguments?: JsonObject;

  /**
   * @generated from field: string idempotency_key = 3;
   */
  idempotencyKey: string;

  /**
   * @generated from field: string trace_id = 4;
   */
  traceId: string;
};

/**
 * Describes the message chalk.agent.v1.AddToolCallRequest.
 * Use `create(AddToolCallRequestSchema)` to create a new message.
 */
export const AddToolCallRequestSchema: GenMessage<AddToolCallRequest> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 29);

/**
 * @generated from message chalk.agent.v1.AddMessageResponse
 */
export type AddMessageResponse = Message<"chalk.agent.v1.AddMessageResponse"> & {
  /**
   * @generated from field: chalk.agent.v1.AgentMessage message = 1;
   */
  message?: AgentMessage;
};

/**
 * Describes the message chalk.agent.v1.AddMessageResponse.
 * Use `create(AddMessageResponseSchema)` to create a new message.
 */
export const AddMessageResponseSchema: GenMessage<AddMessageResponse> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 30);

/**
 * @generated from message chalk.agent.v1.UpdateMessageStatusRequest
 */
export type UpdateMessageStatusRequest = Message<"chalk.agent.v1.UpdateMessageStatusRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: chalk.agent.v1.AgentMessageStatus status = 2;
   */
  status: AgentMessageStatus;

  /**
   * @generated from field: string conversation_id = 3;
   */
  conversationId: string;
};

/**
 * Describes the message chalk.agent.v1.UpdateMessageStatusRequest.
 * Use `create(UpdateMessageStatusRequestSchema)` to create a new message.
 */
export const UpdateMessageStatusRequestSchema: GenMessage<UpdateMessageStatusRequest> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 31);

/**
 * @generated from message chalk.agent.v1.UpdateMessageStatusResponse
 */
export type UpdateMessageStatusResponse = Message<"chalk.agent.v1.UpdateMessageStatusResponse"> & {
  /**
   * @generated from field: chalk.agent.v1.AgentMessage message = 1;
   */
  message?: AgentMessage;
};

/**
 * Describes the message chalk.agent.v1.UpdateMessageStatusResponse.
 * Use `create(UpdateMessageStatusResponseSchema)` to create a new message.
 */
export const UpdateMessageStatusResponseSchema: GenMessage<UpdateMessageStatusResponse> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 32);

/**
 * @generated from message chalk.agent.v1.SetMessageFeedbackRequest
 */
export type SetMessageFeedbackRequest = Message<"chalk.agent.v1.SetMessageFeedbackRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: string message_id = 2;
   */
  messageId: string;

  /**
   * @generated from field: chalk.agent.v1.AgentMessageFeedback feedback = 3;
   */
  feedback: AgentMessageFeedback;

  /**
   * @generated from field: optional string comments = 4;
   */
  comments?: string;
};

/**
 * Describes the message chalk.agent.v1.SetMessageFeedbackRequest.
 * Use `create(SetMessageFeedbackRequestSchema)` to create a new message.
 */
export const SetMessageFeedbackRequestSchema: GenMessage<SetMessageFeedbackRequest> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 33);

/**
 * @generated from message chalk.agent.v1.SetMessageFeedbackResponse
 */
export type SetMessageFeedbackResponse = Message<"chalk.agent.v1.SetMessageFeedbackResponse"> & {
};

/**
 * Describes the message chalk.agent.v1.SetMessageFeedbackResponse.
 * Use `create(SetMessageFeedbackResponseSchema)` to create a new message.
 */
export const SetMessageFeedbackResponseSchema: GenMessage<SetMessageFeedbackResponse> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 34);

/**
 * @generated from message chalk.agent.v1.ListMessagesRequest
 */
export type ListMessagesRequest = Message<"chalk.agent.v1.ListMessagesRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: optional int32 page_size = 2;
   */
  pageSize?: number;

  /**
   * Opaque token for the next page of older messages. Omit to load the latest
   * page. A page token cannot be combined with after_sequence.
   *
   * @generated from field: optional string page_token = 3;
   */
  pageToken?: string;

  /**
   * Return messages strictly newer than this sequence. Active conversations
   * use this to poll for transcript changes without reloading older pages.
   *
   * @generated from field: optional int32 after_sequence = 4;
   */
  afterSequence?: number;
};

/**
 * Describes the message chalk.agent.v1.ListMessagesRequest.
 * Use `create(ListMessagesRequestSchema)` to create a new message.
 */
export const ListMessagesRequestSchema: GenMessage<ListMessagesRequest> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 35);

/**
 * @generated from message chalk.agent.v1.ListMessagesResponse
 */
export type ListMessagesResponse = Message<"chalk.agent.v1.ListMessagesResponse"> & {
  /**
   * @generated from field: repeated chalk.agent.v1.AgentMessage messages = 1;
   */
  messages: AgentMessage[];

  /**
   * @generated from field: optional string next_page_token = 2;
   */
  nextPageToken?: string;

  /**
   * @generated from field: optional int32 next_after_sequence = 3;
   */
  nextAfterSequence?: number;
};

/**
 * Describes the message chalk.agent.v1.ListMessagesResponse.
 * Use `create(ListMessagesResponseSchema)` to create a new message.
 */
export const ListMessagesResponseSchema: GenMessage<ListMessagesResponse> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 36);

/**
 * @generated from message chalk.agent.v1.AddToolResultRequest
 */
export type AddToolResultRequest = Message<"chalk.agent.v1.AddToolResultRequest"> & {
  /**
   * @generated from field: string tool_call_id = 1;
   */
  toolCallId: string;

  /**
   * @generated from field: bool is_error = 2;
   */
  isError: boolean;

  /**
   * @generated from field: google.protobuf.Struct result = 3;
   */
  result?: JsonObject;

  /**
   * @generated from field: string raw_text = 4;
   */
  rawText: string;

  /**
   * @generated from field: int32 latency_ms = 5;
   */
  latencyMs: number;

  /**
   * @generated from field: google.protobuf.Struct metadata = 6;
   */
  metadata?: JsonObject;

  /**
   * @generated from field: string conversation_id = 7;
   */
  conversationId: string;
};

/**
 * Describes the message chalk.agent.v1.AddToolResultRequest.
 * Use `create(AddToolResultRequestSchema)` to create a new message.
 */
export const AddToolResultRequestSchema: GenMessage<AddToolResultRequest> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 37);

/**
 * @generated from message chalk.agent.v1.AddToolResultResponse
 */
export type AddToolResultResponse = Message<"chalk.agent.v1.AddToolResultResponse"> & {
  /**
   * @generated from field: chalk.agent.v1.AgentToolResult tool_result = 1;
   */
  toolResult?: AgentToolResult;
};

/**
 * Describes the message chalk.agent.v1.AddToolResultResponse.
 * Use `create(AddToolResultResponseSchema)` to create a new message.
 */
export const AddToolResultResponseSchema: GenMessage<AddToolResultResponse> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 38);

/**
 * Wholesale-replaces a conversation's transcript (all messages, tool calls,
 * and tool results) with the supplied messages. Intended for Chalk admins
 * re-working a conversation for a demo. Message/tool-call/tool-result ids,
 * sequences, and created_at timestamps are reassigned server-side; incoming
 * parent_message_id values are remapped when they reference another message id
 * in the same request (in an earlier position) and dropped otherwise.
 *
 * @generated from message chalk.agent.v1.ReplaceConversationTranscriptRequest
 */
export type ReplaceConversationTranscriptRequest = Message<"chalk.agent.v1.ReplaceConversationTranscriptRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * The new transcript, in order. Only role, content, status, metadata,
   * parent_message_id, and tool_calls (name, arguments, status, result) are
   * honored; identity and timestamp fields are ignored.
   *
   * @generated from field: repeated chalk.agent.v1.AgentMessage messages = 2;
   */
  messages: AgentMessage[];
};

/**
 * Describes the message chalk.agent.v1.ReplaceConversationTranscriptRequest.
 * Use `create(ReplaceConversationTranscriptRequestSchema)` to create a new message.
 */
export const ReplaceConversationTranscriptRequestSchema: GenMessage<ReplaceConversationTranscriptRequest> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 39);

/**
 * @generated from message chalk.agent.v1.ReplaceConversationTranscriptResponse
 */
export type ReplaceConversationTranscriptResponse = Message<"chalk.agent.v1.ReplaceConversationTranscriptResponse"> & {
  /**
   * The stored transcript, with freshly assigned ids and sequences.
   *
   * @generated from field: repeated chalk.agent.v1.AgentMessage messages = 1;
   */
  messages: AgentMessage[];
};

/**
 * Describes the message chalk.agent.v1.ReplaceConversationTranscriptResponse.
 * Use `create(ReplaceConversationTranscriptResponseSchema)` to create a new message.
 */
export const ReplaceConversationTranscriptResponseSchema: GenMessage<ReplaceConversationTranscriptResponse> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 40);

/**
 * Points a conversation at a notebook and replaces any notebook-kind artifact
 * links so the two metadata-plane representations cannot drift. An empty
 * notebook_id detaches the conversation from its notebook.
 *
 * @generated from message chalk.agent.v1.SetConversationNotebookRequest
 */
export type SetConversationNotebookRequest = Message<"chalk.agent.v1.SetConversationNotebookRequest"> & {
  /**
   * @generated from field: string conversation_id = 1;
   */
  conversationId: string;

  /**
   * @generated from field: string notebook_id = 2;
   */
  notebookId: string;
};

/**
 * Describes the message chalk.agent.v1.SetConversationNotebookRequest.
 * Use `create(SetConversationNotebookRequestSchema)` to create a new message.
 */
export const SetConversationNotebookRequestSchema: GenMessage<SetConversationNotebookRequest> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 41);

/**
 * @generated from message chalk.agent.v1.SetConversationNotebookResponse
 */
export type SetConversationNotebookResponse = Message<"chalk.agent.v1.SetConversationNotebookResponse"> & {
  /**
   * @generated from field: chalk.agent.v1.AgentConversation conversation = 1;
   */
  conversation?: AgentConversation;
};

/**
 * Describes the message chalk.agent.v1.SetConversationNotebookResponse.
 * Use `create(SetConversationNotebookResponseSchema)` to create a new message.
 */
export const SetConversationNotebookResponseSchema: GenMessage<SetConversationNotebookResponse> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 42);

/**
 * Inserts a pre-built agent trace (e.g. a re-worked copy of a live session's
 * spans) into the environment's telemetry store through the same otel ingest
 * route live agent-conversation sessions export through. The
 * chalk.environment_id resource attribute is overwritten server-side with the
 * caller's environment, so a trace can only be inserted into the environment
 * it is uploaded to.
 *
 * @generated from message chalk.agent.v1.UploadAgentTraceRequest
 */
export type UploadAgentTraceRequest = Message<"chalk.agent.v1.UploadAgentTraceRequest"> & {
  /**
   * gzip-compressed, serialized opentelemetry.proto.collector.trace.v1
   * ExportTraceServiceRequest protobuf containing the trace + spans.
   *
   * @generated from field: bytes gzipped_trace_request = 1;
   */
  gzippedTraceRequest: Uint8Array;
};

/**
 * Describes the message chalk.agent.v1.UploadAgentTraceRequest.
 * Use `create(UploadAgentTraceRequestSchema)` to create a new message.
 */
export const UploadAgentTraceRequestSchema: GenMessage<UploadAgentTraceRequest> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 43);

/**
 * @generated from message chalk.agent.v1.UploadAgentTraceResponse
 */
export type UploadAgentTraceResponse = Message<"chalk.agent.v1.UploadAgentTraceResponse"> & {
  /**
   * Number of spans inserted.
   *
   * @generated from field: int32 span_count = 1;
   */
  spanCount: number;

  /**
   * Distinct trace ids (lowercase hex) present in the uploaded spans.
   *
   * @generated from field: repeated string trace_ids = 2;
   */
  traceIds: string[];
};

/**
 * Describes the message chalk.agent.v1.UploadAgentTraceResponse.
 * Use `create(UploadAgentTraceResponseSchema)` to create a new message.
 */
export const UploadAgentTraceResponseSchema: GenMessage<UploadAgentTraceResponse> = /*@__PURE__*/
  messageDesc(file_chalk_agent_v1_conversation, 44);

/**
 * @generated from enum chalk.agent.v1.AgentMessageRole
 */
export enum AgentMessageRole {
  /**
   * @generated from enum value: AGENT_MESSAGE_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AGENT_MESSAGE_ROLE_USER = 1;
   */
  USER = 1,

  /**
   * @generated from enum value: AGENT_MESSAGE_ROLE_ASSISTANT = 2;
   */
  ASSISTANT = 2,

  /**
   * @generated from enum value: AGENT_MESSAGE_ROLE_SYSTEM = 3;
   */
  SYSTEM = 3,

  /**
   * @generated from enum value: AGENT_MESSAGE_ROLE_TOOL = 4;
   */
  TOOL = 4,
}

/**
 * Describes the enum chalk.agent.v1.AgentMessageRole.
 */
export const AgentMessageRoleSchema: GenEnum<AgentMessageRole> = /*@__PURE__*/
  enumDesc(file_chalk_agent_v1_conversation, 0);

/**
 * @generated from enum chalk.agent.v1.AgentMessageStatus
 */
export enum AgentMessageStatus {
  /**
   * @generated from enum value: AGENT_MESSAGE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AGENT_MESSAGE_STATUS_STREAMING = 1;
   */
  STREAMING = 1,

  /**
   * @generated from enum value: AGENT_MESSAGE_STATUS_FINAL = 2;
   */
  FINAL = 2,

  /**
   * @generated from enum value: AGENT_MESSAGE_STATUS_ERROR = 3;
   */
  ERROR = 3,
}

/**
 * Describes the enum chalk.agent.v1.AgentMessageStatus.
 */
export const AgentMessageStatusSchema: GenEnum<AgentMessageStatus> = /*@__PURE__*/
  enumDesc(file_chalk_agent_v1_conversation, 1);

/**
 * @generated from enum chalk.agent.v1.AgentMessageFeedback
 */
export enum AgentMessageFeedback {
  /**
   * @generated from enum value: AGENT_MESSAGE_FEEDBACK_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AGENT_MESSAGE_FEEDBACK_GOOD = 1;
   */
  GOOD = 1,

  /**
   * @generated from enum value: AGENT_MESSAGE_FEEDBACK_BAD = 2;
   */
  BAD = 2,
}

/**
 * Describes the enum chalk.agent.v1.AgentMessageFeedback.
 */
export const AgentMessageFeedbackSchema: GenEnum<AgentMessageFeedback> = /*@__PURE__*/
  enumDesc(file_chalk_agent_v1_conversation, 2);

/**
 * @generated from enum chalk.agent.v1.AgentConversationStatus
 */
export enum AgentConversationStatus {
  /**
   * @generated from enum value: AGENT_CONVERSATION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * The runner is actively advancing the conversation (a turn is running).
   *
   * @generated from enum value: AGENT_CONVERSATION_STATUS_IN_PROGRESS = 1;
   */
  IN_PROGRESS = 1,

  /**
   * The last turn finished; the conversation is waiting on the user.
   *
   * @generated from enum value: AGENT_CONVERSATION_STATUS_AWAITING_USER_INPUT = 2;
   */
  AWAITING_USER_INPUT = 2,

  /**
   * The conversation was explicitly marked done and expects no further turns.
   *
   * @generated from enum value: AGENT_CONVERSATION_STATUS_COMPLETED = 3;
   */
  COMPLETED = 3,

  /**
   * An interactive turn is paused before a tool with side effects.
   *
   * @generated from enum value: AGENT_CONVERSATION_STATUS_AWAITING_TOOL_APPROVAL = 4;
   */
  AWAITING_TOOL_APPROVAL = 4,
}

/**
 * Describes the enum chalk.agent.v1.AgentConversationStatus.
 */
export const AgentConversationStatusSchema: GenEnum<AgentConversationStatus> = /*@__PURE__*/
  enumDesc(file_chalk_agent_v1_conversation, 3);

/**
 * Publication state of the metadata header relative to its data-plane
 * content. Numeric values are persisted directly in metadata PostgreSQL and
 * must never be renumbered.
 *
 * @generated from enum chalk.agent.v1.AgentConversationContentState
 */
export enum AgentConversationContentState {
  /**
   * @generated from enum value: AGENT_CONVERSATION_CONTENT_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AGENT_CONVERSATION_CONTENT_STATE_PROVISIONING = 1;
   */
  PROVISIONING = 1,

  /**
   * @generated from enum value: AGENT_CONVERSATION_CONTENT_STATE_READY = 2;
   */
  READY = 2,

  /**
   * @generated from enum value: AGENT_CONVERSATION_CONTENT_STATE_DELETING = 3;
   */
  DELETING = 3,

  /**
   * @generated from enum value: AGENT_CONVERSATION_CONTENT_STATE_REPAIR_REQUIRED = 4;
   */
  REPAIR_REQUIRED = 4,
}

/**
 * Describes the enum chalk.agent.v1.AgentConversationContentState.
 */
export const AgentConversationContentStateSchema: GenEnum<AgentConversationContentState> = /*@__PURE__*/
  enumDesc(file_chalk_agent_v1_conversation, 4);

/**
 * Kinds of external resources ("artifacts") that can be linked to a
 * conversation — resources the conversation created or touched, identified by
 * their id in their own table/service.
 *
 * @generated from enum chalk.agent.v1.AgentArtifactKind
 */
export enum AgentArtifactKind {
  /**
   * @generated from enum value: AGENT_ARTIFACT_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AGENT_ARTIFACT_KIND_NOTEBOOK = 1;
   */
  NOTEBOOK = 1,

  /**
   * @generated from enum value: AGENT_ARTIFACT_KIND_SANDBOX = 2;
   */
  SANDBOX = 2,
}

/**
 * Describes the enum chalk.agent.v1.AgentArtifactKind.
 */
export const AgentArtifactKindSchema: GenEnum<AgentArtifactKind> = /*@__PURE__*/
  enumDesc(file_chalk_agent_v1_conversation, 5);

/**
 * @generated from enum chalk.agent.v1.AgentToolCallStatus
 */
export enum AgentToolCallStatus {
  /**
   * @generated from enum value: AGENT_TOOL_CALL_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AGENT_TOOL_CALL_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: AGENT_TOOL_CALL_STATUS_RUNNING = 2;
   */
  RUNNING = 2,

  /**
   * @generated from enum value: AGENT_TOOL_CALL_STATUS_COMPLETED = 3;
   */
  COMPLETED = 3,

  /**
   * @generated from enum value: AGENT_TOOL_CALL_STATUS_FAILED = 4;
   */
  FAILED = 4,

  /**
   * @generated from enum value: AGENT_TOOL_CALL_STATUS_AWAITING_APPROVAL = 5;
   */
  AWAITING_APPROVAL = 5,

  /**
   * @generated from enum value: AGENT_TOOL_CALL_STATUS_APPROVED = 6;
   */
  APPROVED = 6,

  /**
   * @generated from enum value: AGENT_TOOL_CALL_STATUS_DENIED = 7;
   */
  DENIED = 7,
}

/**
 * Describes the enum chalk.agent.v1.AgentToolCallStatus.
 */
export const AgentToolCallStatusSchema: GenEnum<AgentToolCallStatus> = /*@__PURE__*/
  enumDesc(file_chalk_agent_v1_conversation, 6);

/**
 * @generated from enum chalk.agent.v1.AgentConversationSortColumn
 */
export enum AgentConversationSortColumn {
  /**
   * Treated as CREATED_AT.
   *
   * @generated from enum value: AGENT_CONVERSATION_SORT_COLUMN_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AGENT_CONVERSATION_SORT_COLUMN_CREATED_AT = 1;
   */
  CREATED_AT = 1,

  /**
   * @generated from enum value: AGENT_CONVERSATION_SORT_COLUMN_UPDATED_AT = 2;
   */
  UPDATED_AT = 2,
}

/**
 * Describes the enum chalk.agent.v1.AgentConversationSortColumn.
 */
export const AgentConversationSortColumnSchema: GenEnum<AgentConversationSortColumn> = /*@__PURE__*/
  enumDesc(file_chalk_agent_v1_conversation, 7);

/**
 * @generated from enum chalk.agent.v1.AgentConversationSortOrder
 */
export enum AgentConversationSortOrder {
  /**
   * Treated as DESC.
   *
   * @generated from enum value: AGENT_CONVERSATION_SORT_ORDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AGENT_CONVERSATION_SORT_ORDER_DESC = 1;
   */
  DESC = 1,

  /**
   * @generated from enum value: AGENT_CONVERSATION_SORT_ORDER_ASC = 2;
   */
  ASC = 2,
}

/**
 * Describes the enum chalk.agent.v1.AgentConversationSortOrder.
 */
export const AgentConversationSortOrderSchema: GenEnum<AgentConversationSortOrder> = /*@__PURE__*/
  enumDesc(file_chalk_agent_v1_conversation, 8);

/**
 * @generated from enum chalk.agent.v1.ForkProviderSource
 */
export enum ForkProviderSource {
  /**
   * @generated from enum value: FORK_PROVIDER_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FORK_PROVIDER_SOURCE_CONVERSATION = 1;
   */
  CONVERSATION = 1,

  /**
   * @generated from enum value: FORK_PROVIDER_SOURCE_ENVIRONMENT_DEFAULT = 2;
   */
  ENVIRONMENT_DEFAULT = 2,
}

/**
 * Describes the enum chalk.agent.v1.ForkProviderSource.
 */
export const ForkProviderSourceSchema: GenEnum<ForkProviderSource> = /*@__PURE__*/
  enumDesc(file_chalk_agent_v1_conversation, 9);

/**
 * @generated from service chalk.agent.v1.AgentConversationService
 */
export const AgentConversationService: GenService<{
  /**
   * @generated from rpc chalk.agent.v1.AgentConversationService.CreateConversation
   */
  createConversation: {
    methodKind: "unary";
    input: typeof CreateConversationRequestSchema;
    output: typeof CreateConversationResponseSchema;
  },
  /**
   * @generated from rpc chalk.agent.v1.AgentConversationService.GetConversation
   */
  getConversation: {
    methodKind: "unary";
    input: typeof GetConversationRequestSchema;
    output: typeof GetConversationResponseSchema;
  },
  /**
   * @generated from rpc chalk.agent.v1.AgentConversationService.GetConversationForkFamily
   */
  getConversationForkFamily: {
    methodKind: "unary";
    input: typeof GetConversationForkFamilyRequestSchema;
    output: typeof GetConversationForkFamilyResponseSchema;
  },
  /**
   * @generated from rpc chalk.agent.v1.AgentConversationService.ListConversations
   */
  listConversations: {
    methodKind: "unary";
    input: typeof ListConversationsRequestSchema;
    output: typeof ListConversationsResponseSchema;
  },
  /**
   * @generated from rpc chalk.agent.v1.AgentConversationService.UpdateConversation
   */
  updateConversation: {
    methodKind: "unary";
    input: typeof UpdateConversationRequestSchema;
    output: typeof UpdateConversationResponseSchema;
  },
  /**
   * @generated from rpc chalk.agent.v1.AgentConversationService.DeleteConversation
   */
  deleteConversation: {
    methodKind: "unary";
    input: typeof DeleteConversationRequestSchema;
    output: typeof DeleteConversationResponseSchema;
  },
  /**
   * @generated from rpc chalk.agent.v1.AgentConversationService.ForkConversation
   */
  forkConversation: {
    methodKind: "unary";
    input: typeof ForkConversationRequestSchema;
    output: typeof ForkConversationResponseSchema;
  },
  /**
   * @generated from rpc chalk.agent.v1.AgentConversationService.LinkArtifact
   */
  linkArtifact: {
    methodKind: "unary";
    input: typeof LinkArtifactRequestSchema;
    output: typeof LinkArtifactResponseSchema;
  },
  /**
   * @generated from rpc chalk.agent.v1.AgentConversationService.UnlinkArtifact
   */
  unlinkArtifact: {
    methodKind: "unary";
    input: typeof UnlinkArtifactRequestSchema;
    output: typeof UnlinkArtifactResponseSchema;
  },
  /**
   * @generated from rpc chalk.agent.v1.AgentConversationService.ListArtifacts
   */
  listArtifacts: {
    methodKind: "unary";
    input: typeof ListArtifactsRequestSchema;
    output: typeof ListArtifactsResponseSchema;
  },
  /**
   * @generated from rpc chalk.agent.v1.AgentConversationService.ListConversationsForArtifact
   */
  listConversationsForArtifact: {
    methodKind: "unary";
    input: typeof ListConversationsForArtifactRequestSchema;
    output: typeof ListConversationsForArtifactResponseSchema;
  },
  /**
   * @generated from rpc chalk.agent.v1.AgentConversationService.AddMessage
   */
  addMessage: {
    methodKind: "unary";
    input: typeof AddMessageRequestSchema;
    output: typeof AddMessageResponseSchema;
  },
  /**
   * @generated from rpc chalk.agent.v1.AgentConversationService.UpdateMessageStatus
   */
  updateMessageStatus: {
    methodKind: "unary";
    input: typeof UpdateMessageStatusRequestSchema;
    output: typeof UpdateMessageStatusResponseSchema;
  },
  /**
   * @generated from rpc chalk.agent.v1.AgentConversationService.SetMessageFeedback
   */
  setMessageFeedback: {
    methodKind: "unary";
    input: typeof SetMessageFeedbackRequestSchema;
    output: typeof SetMessageFeedbackResponseSchema;
  },
  /**
   * @generated from rpc chalk.agent.v1.AgentConversationService.ListMessages
   */
  listMessages: {
    methodKind: "unary";
    input: typeof ListMessagesRequestSchema;
    output: typeof ListMessagesResponseSchema;
  },
  /**
   * @generated from rpc chalk.agent.v1.AgentConversationService.AddToolResult
   */
  addToolResult: {
    methodKind: "unary";
    input: typeof AddToolResultRequestSchema;
    output: typeof AddToolResultResponseSchema;
  },
  /**
   * Admin-only transcript editing, for re-working conversations (e.g. demos).
   *
   * @generated from rpc chalk.agent.v1.AgentConversationService.ReplaceConversationTranscript
   */
  replaceConversationTranscript: {
    methodKind: "unary";
    input: typeof ReplaceConversationTranscriptRequestSchema;
    output: typeof ReplaceConversationTranscriptResponseSchema;
  },
  /**
   * Admin-only: re-point (or detach) the notebook a conversation is bound to.
   *
   * @generated from rpc chalk.agent.v1.AgentConversationService.SetConversationNotebook
   */
  setConversationNotebook: {
    methodKind: "unary";
    input: typeof SetConversationNotebookRequestSchema;
    output: typeof SetConversationNotebookResponseSchema;
  },
  /**
   * Admin-only: insert a pre-built agent trace into the environment's
   * telemetry store (demo re-working).
   *
   * @generated from rpc chalk.agent.v1.AgentConversationService.UploadAgentTrace
   */
  uploadAgentTrace: {
    methodKind: "unary";
    input: typeof UploadAgentTraceRequestSchema;
    output: typeof UploadAgentTraceResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_chalk_agent_v1_conversation, 0);

